var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"mapEl",staticClass:"terrain-location-picker-map",attrs:{"role":"img","aria-label":"Mapa para confirmar o ajustar la ubicación"}})
}
var staticRenderFns = []

export { render, staticRenderFns }